import React, { useEffect, useRef, useState } from 'react'
import { deleteRegistration, getRegistrations } from '../../features/manageSSO/manageSSOService';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { Button, Chip, TextField } from '@mui/material';
import { EnvironmentRegistry } from '../../services/registry/environmentRegistry';
import AddIcon from '@mui/icons-material/Add';
import CreateNewReg from './CreateNewReg';
import { ConfirmationPopUp } from '../popup/confirmationPopUp';
import SPMetadataGenerator from './SPMetadataGenerator';




function SSOSaml() {

  const [loading , setLoading] = useState<boolean>(false);
  const [registrationData , setRegistrationData] = useState<any[]>([]);
  const [searchVal , setSearchVal] = useState<string>("");
  const [open , setOpen] = useState<boolean>(false);
  const [metaGeneratorOpen , setMetaGeneratorOpen] = useState<boolean>(false);

  const [openConfimation , setOpenConfimation] = useState({open:false , message:''});

  const selectedData = useRef<any>(null);
  const successMethodRef = useRef(()=>{});


  const handleTryNowClick =(enabled:boolean ,data:Record<string,string>)=>{
    if(!enabled){
      openPopup("Alert","You cannot test sso login from IDP registration. Please add SP metadata registration(ignore if already done) and try there")
    }else{
      const url = EnvironmentRegistry.getServerUrl()+data['loginUrl']+"?page="+window.location.origin+window.location.pathname;
      window.open(url,"_blank", 'directories=no,titlebar=no,toolbar=no,status=no,menubar=no,location=no,height=570,width=520,scrollbars=yes');
    }

  } 

  const handleDelete = async(id:string)=>{
    successMethodRef.current = async()=>{
      try {
        await deleteRegistration(id);
        openPopup("Success","Data deleted successfully");
        init();
      } catch (error) {
        openPopup("Error","Error while deleting data");
        console.error(error)
      }
    }
    setOpenConfimation({open:true , message:'Are you sure you want to delete ?'});
  }


  const handleEditClick = (id:string)=>{
    const element = registrationData?.find((item)=>item.registrationId == id);
    selectedData.current = element;
    setOpen(true);
  }

  const handleAddClick = ()=>{
    setOpen(true);
    selectedData.current = null;
  }


  function createColumns():GridColDef<any>[]{
    return [
      {
        field:'registrationId',
        headerName:'Reg ID',
        sortable: false,
        disableColumnMenu: true,
        flex:4,
        minWidth:200
      },
      {
        field:'enable',
        headerName:'Status',
        sortable: false,
        disableColumnMenu: true,
        renderCell:(params)=>{
          const isEnable = params?.row?.enable ?? false;
          return <Chip sx={{background:isEnable ? '#5fb15f':'#fb671f' , color:'white',fontWeight:'700'}} label={isEnable ? 'Active':'Disabled'}/>
        },
        flex:1,
      },
      {
        field:'clientName',
        headerName:'Name',
        disableColumnMenu: true,
        width:200,
        flex:2
      },
      {
        field:'type',
        headerName:'Type',
        sortable: false,
        disableColumnMenu: true,
        flex:1
      },
      {
        field:'operation',
        headerName:'Operations',
        sortable: false,
        flex:1,
        disableColumnMenu: true,
        renderCell: (params) => {
          return <div className='operation-wrapper'>
            <EditOutlinedIcon sx={{cursor:'pointer'}} onClick={()=>handleEditClick(params.row.id)} />
            <DeleteOutlineOutlinedIcon sx={{cursor:'pointer'}} onClick={()=>handleDelete(params.row.id)}/>
          </div>
        }
      },
      {
        field:'tryBtn',
        headerName:'',
        flex:1,
        sortable: false,
        disableColumnMenu: true,
        renderCell: (params) => {
          const disabled = !params.row.tryBtn;
          return <Button variant='contained' onClick={()=>handleTryNowClick(!disabled , params.row)} className={`tryBtn ${disabled ? 'tryBtnDisabled':''}`}>Try</Button>
        }
      }
    ]
  }

  function createRows(registrations: any[]):any[] {

    const cols = [...createColumns() , { field:'loginUrl'}];

    const r: any = registrations.map((dataItem) => cols.reduce((acc, curr, idx) => {
      if (curr.field === "type") {
        acc = {
          ...acc,
          [curr.field]: dataItem?.extras?.type ?? "-"
        }
      } else {
        acc = {
          ...acc,
          [curr.field]: curr.field === "tryBtn" ? dataItem['loginUrl'] && dataItem['extras'].type == "SP" : dataItem[curr.field] ?? "-"
        }
      }
      return acc;
    }, {})
    ).map((item: Record<any, any>) => ({ ...item, id: item["registrationId"] }))?.filter((item: Record<string, string | number>) => {
      const searchKeys = ["clientName", "id", "loginUrl", "registrationId", "type"];
      for (let key of searchKeys) {
        let val = item[key]?.toString()?.toLowerCase() ?? "";
        if (val.includes(searchVal.trim().toLowerCase())) return item;
      }
    });

    return r;
  }

  async function init() {
    try {
      setLoading(true);
      const registrations = await getRegistrations();
      setRegistrationData(registrations);
      createRows(registrations);
    } catch (err) {
      console.error(err);
      openPopup("Error", "Failed to get SAML Registrations");
    } finally {
      setLoading(false);
    }
  }

  useEffect(()=>{
    init();
  },[]);



  return (
    <div className='sso-saml-wrapper'>

      <div className="sso-saml-action-btns-wrapper">
        <Button variant='contained' startIcon={<AddIcon/>} onClick={handleAddClick}>ADD</Button>
        <Button variant='contained' onClick={()=>setMetaGeneratorOpen(true)}>Generate SP Metadata</Button>
      </div>

      <TextField placeholder='Search' size='small' className='sso-saml-searchfield' onChange={(e)=>setSearchVal(e?.target?.value ?? "")}/>
      
      <div className="sso-saml-table-wrapper" style={{overflow:'auto'}}>
        <DataGrid
          rows={createRows(registrationData)}
          loading={loading}
          columns={createColumns()}
          sx={{
            height: '400px',
            "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                outline: "none !important",
              }
          }}
          disableRowSelectionOnClick
        />
      </div>


      <CreateNewReg open={open} setOpen={setOpen} selectedData={selectedData.current} init={init}/>
      <SPMetadataGenerator open={metaGeneratorOpen} setOpen={setMetaGeneratorOpen} registrationData={registrationData}/>
      
      
      
      <ConfirmationPopUp
        message={openConfimation.message}
        openConfirmModal={openConfimation.open}
        setOpenConfirmModal={
          () => {
            setOpenConfimation({ open: false, message: '' });
          }
        }
        successMethod={successMethodRef.current} />
    </div>
  )
}

export default SSOSaml